<template>
  <div>
    <button @click="popupActivo=true" class="info-button">Find out more</button>
    <vs-popup button-close-hidden class="find-more"  title="Lorem ipsum dolor sit amet" :active.sync="popupActivo">
      <div class="w-full mx-auto p-16 bg-white rounded-lg shadow-md text-sm space-y-6">
        <div class="border-0 z-0">
          <div class="flex justify-between items-start">
            <span></span>
            <div class="flex gap-1 items-center cursor-pointer font-semibold" @click="popupActivo=false">
              <p class="text-black">Close</p>
              <feather-icon icon="XIcon" svgClasses="h-4 w-4" class="text-black font-bold" />
            </div>
          </div>
        </div>
        <div>
          <div class="flex justify-between items-start mt-12">
            <h2 class="text-2xl font-semibold">How the Dispense Request Works</h2>
          </div>
        </div>
        <!-- Do Section -->
        <div class="mb-4">
          <h3 class="font-bold text-lg mb-4">Do:</h3>
          <ul class="space-y-3 text-lg">
            <li class="flex items-center gap-4">
              <div class="shrink-0">
                <div
                  class="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-75"
                >
                  <feather-icon icon="CheckIcon" svgClasses="h-7 w-7" class="text-green-700 font-bold" />
                </div>
              </div>
              <span class="leading-custom">
                You are requesting products <strong>only for patients with a confirmed upcoming appointment</strong>.
              </span>
            </li>
            <li class="flex items-center gap-4">
              <div class="shrink-0">
                <div
                  class="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-75"
                >
                  <feather-icon icon="CheckIcon" svgClasses="h-7 w-7" class="text-green-700 font-bold" />
                </div>
              </div>
              <span class="leading-custom">
                <strong>A maximum of 10 patients</strong> can be included per dispense request. If you require more, please submit an additional form.
              </span>
            </li>
            <li class="flex items-start gap-4">
              <div class="shrink-0">
                <div
                  class="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-75"
                >
                  <feather-icon icon="CheckIcon" svgClasses="h-7 w-7" class="text-green-700 font-bold" />
                </div>
              </div>
              <div class="text-lg mt-1">
                <p class="leading-custom">
                  We recommend you <strong>collect full or partial payment</strong> from each patient prior to submitting the request, as dispensed products:
                </p>
                <div class="flex items-start gap-2 text-blue-800 mt-3">
                  <div class="w-2 h-2 bg-blue-800 rounded-full mt-2 flex-shrink-0"></div>
                  <p class="leading-custom">
                    Must be held in clinic
                    <strong>
                      until either product expiry as per the Product Information, or disposed of
                    </strong>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- Don't Section -->
        <div>
          <h3 class="font-bold text-lg mb-4">Don’t:</h3>
          <ul class="space-y-4 text-red-600 font-semibold text-lg">
            <li class="flex items-center gap-4">
              <div class="shrink-0">
                <div
                  class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-75"
                >
                  <feather-icon icon="XIcon" svgClasses="h-7 w-7" class="text-red-700 font-bold" />
                </div>
              </div>
              <span>Dispense requests cannot be reused for another patient</span>
            </li>
            <li class="flex items-center gap-4">
              <div class="shrink-0">
                <div
                  class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-75"
                >
                  <feather-icon icon="XIcon" svgClasses="h-7 w-7" class="text-red-700 font-bold" />
                </div>
              </div>
              <span>Cannot be relabelled</span>
            </li>
            <li class="flex items-center gap-4">
              <div class="shrink-0">
                <div
                  class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-75"
                >
                  <feather-icon icon="XIcon" svgClasses="h-7 w-7" class="text-red-700 font-bold" />
                </div>
              </div>
              <span>Cannot be returned to the pharmacy</span>
            </li>
          </ul>
        </div>
        <vs-divider class="py-6"></vs-divider> 
        <section class="delivery-note" role="article" aria-labelledby="delivery-responsibilities">
          <h3 id="delivery-responsibilities" class="font-bold text-lg">Responsibilities:</h3>
          <div class="dn-item">
            <h4 class="dn-subhead text-lg">Clinic availability:</h4>
            <p class="dn-text text-lg">
              You are expected to be in clinic during standard business hours. If you are unavailable, it is your responsibility to manage this.
            </p>
          </div>
          <div class="dn-item">
            <h4 class="dn-subhead text-lg">Delivery timing:</h4>
            <p class="dn-text text-lg">
              Deliveries may arrive outside business hours, and timing cannot be guaranteed.
            </p>
          </div>
          <div class="dn-item text-lg">
            <h4 class="dn-subhead text-lg">If you miss a delivery:</h4>
            <p class="dn-text text-lg">
              Your parcel will be redirected to your Local Post Office (LPO), where it must be collected within 24 hours of availability.
            </p>
          </div>
          <div class="dn-item text-lg">
            <h4 class="dn-subhead text-lg">Liability:</h4>
            <p class="dn-text text-lg">
              Fresh cannot accept responsibility for, or cover any costs resulting from, parcels not collected within this timeframe — including for breaches of cold chain.
            </p>
          </div>
        </section>
        <vs-divider class="py-6"></vs-divider> 
        <!-- Timelines & Logistics -->
        <div class="border-t pt-4 flex flex-col gap-4">
          <h3 class="font-bold text-lg mb-4">Timelines & Logistics:</h3>
          <div class="flex items-start gap-4 mb-4">
            <div style="background-color: #F3F3F3;" class="text-center border px-3 py-4 rounded-lg">
              <p class="font-bold text-gray-800">24–48</p>
              <p class="text-xs text-gray-500">HOURS</p>
            </div>
            <p class="text-lg text-new-primary leading-custom">
              Dispense requests typically take 24–48 hours to be fulfilled by the pharmacy, plus shipping time. Please allow sufficient lead time based on patient booking dates.
            </p>
          </div>
          <p class="text-lg text-new-primary leading-custom">
            If for some reason a patient's prescribed medication has not arrived in the clinic before their appointment, their appointment must be postponed.
            <span class="text-red-600 font-semibold">
              You cannot use another patient's medication in the interim, even if it is the same product.
            </span>
          </p>
          <p class="text-lg mt-2 text-new-primary leading-custom">
            We recommend you implement a cross-checking process when receiving product to always ensure patient medicines have been received prior to their day fo appointment.
          </p>
        </div>
        <!-- Monday Note -->
        <div class="more-info-banner text-sm p-4 rounded-md">
          <feather-icon icon="CalendarIcon" svgClasses="h-7 w-7" class="text-blue-700 font-bold mb-2" />
          <div class="flex items-start gap-2">
            <div>
              <p class="font-semibold">Dispense Requests on Monday</p>
              <p class="leading-small">
                To help minimise administrative overhead and shipping costs, we ask that you aim to
                <strong>submit all dispense requests on a Monday where possible</strong>.
                This helps streamline pharmacy operations, reduces the number of deliveries you have to track and accept, reduces unnecessary shipping fees and saves the environmental impact of multiple shipments and packaging.
              </p>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
export default {
  data(){
    return {
      popupActivo:false,
    };
  },
};
</script>
<style lang="css">
  .find-more.con-vs-popup .vs-popup {
    overflow-y:  auto !important;
    width: 60% !important;
    border-radius: 12px !important;
  }

  .more-info-banner {
    border-radius: 8px;
    border: 1px solid #95BFD7;
    background: #EAF5FB !important;
  }

  .leading-custom {
    line-height: 28px;
  }

  .leading-small {
    line-height: 20px;
  }

  .delivery-note {
    max-width: 720px;
    background: #ffffff;
    border-radius: 6px;
    color: #4b5563; /* gray-600 */
    line-height: 1.45;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .dn-subhead {
    margin: 0 0 6px 0;
    font-size: 0.95rem;
    color: #111827; /* gray-900 */
    font-weight: 600;
  }

  @media (max-width: 420px) {
    .delivery-note {
      padding: 14px;
    }
    .dn-title { font-size: .95rem; }
    .dn-subhead { font-size: .9rem; }
    .dn-text { font-size: .825rem; }
  }
</style>
